export default __webpack_public_path__ + "static/media/contemporary.db960959.gif";